import Cookies from "universal-cookie";
import {
    IPasswordCheckParams,
    LOCALE_CODES,
    PASSWORD_CHECK_PARAMS,
    PASSWORD_COMPLEXITY_CHECK_REGEXP
} from "./appConstants";

export const checkIsPasswordValidWithParams = (password: string, paramsList?: IPasswordCheckParams[]) => {
    const complexityCheckParams = paramsList || Object.values(PASSWORD_CHECK_PARAMS);
    return !complexityCheckParams.some((param: IPasswordCheckParams) => {
        const regexp = new RegExp(PASSWORD_COMPLEXITY_CHECK_REGEXP[param]);
        return !regexp.test(password);
    });
};


const cookies = new Cookies();
export const getSystemLocale = (): string => {
    const locale_in_mem = cookies.get('locale');
    if (locale_in_mem && locale_in_mem in LOCALE_CODES)
        return locale_in_mem;
    const browserLocale = (navigator.language || (navigator as Navigator & {
        userLanguage: string
    }).userLanguage).replace('-', '_');
    if (browserLocale in LOCALE_CODES) {
        return browserLocale;
    } else if (browserLocale.split('_')[0] in LOCALE_CODES) {
        return browserLocale.split('_')[0];
    }
    return LOCALE_CODES.en;
}

export const setSystemLocale = (locale: string) => {
    cookies.set('locale', locale, { path: '/', maxAge: 60 * 60 * 24 * 365 });
}
